<template>
<div>

	<div class="panel panel-clinic">
		<!--
		<div class="panel-heading collapsed" href="#form_summary" data-toggle="collapse">

			<div class="arrow-down"></div>

			<h2 class="panel-title">Sammanfatting</h2>

		</div>
		-->

		<div id="form_summary" class="panel-collapse">

			<div class="panel-body">

				<div class="upload-box" v-if="clinic.portrait" v-bind:style="'background-image: url('+clinic.portrait.thumb_url+')'"></div>

				<div class="form-group summary oddevencol">
					<label class="col-md-14 control-label">Prospect tjänsteområde</label>
					<div class="col-md-36">
		            <span :key="'s_product_area_'+area.id" v-for="area in activeProductAreas">
		            	{{ area.name }}<span v-if="area.id == 1 && activeProductAreas.length == 2">,</span>
		            </span>
					</div>
				</div>

				<div class="form-group summary oddevencol">
					<label class="col-md-14 control-label">Område</label>
					<div class="col-md-36">
						{{ clinic.group }}
					</div>
				</div>

				<div class="form-group summary oddevencol" style="background-color: #c9e7e5; margin-top:40px;">
					<div class="col-md-10"></div>
					<div class="col-md-5">
						<b>Avtal</b>
					</div>
					<div class="col-md-10">
						<b>Anslutningsdatum</b>
					</div>
					<div class="col-md-10">
						<b>Avslutningsdatum</b>
					</div>
					<div class="col-md-12">
						<b>Kod</b>
					</div>
				</div>

				<div class="form-group summary oddevencol">
					<div class="col-md-10"><b>Mottagning</b></div>
					<div class="col-md-5">
						<img v-if="clinic.contract_internal == 1" src="/images/check.png" style="width:20px;">
					</div>
					<div class="col-md-10">
						<p v-if="this.meta['date_connected_internal'].value">{{ this.meta['date_connected_internal'].value }}</p>
					</div>
					<div class="col-md-10">
						<p v-if="this.meta['date_disconnected_internal'].value">{{ this.meta['date_disconnected_internal'].value }}</p>
					</div>
					<div class="col-md-12">
						<div v-if="rowMetaComplete('contract_upload_internal')">
							<p v-if="clinic.contract_internal == 1" style="white-space: nowrap;">
								<a :href="'https://k.halsoresurs.se/partner/'+clinic.card_token" target="_blank"><b>QR-kodslänk</b></a> ({{ getSignKey('m') }})
							</p>
							<p v-else><i>Inaktiv</i></p>
						</div>
					</div>
				</div>

				<div class="form-group summary oddevencol">
					<div class="col-md-10"><b>Företag</b></div>
					<div class="col-md-5">
						<img v-if="clinic.contract_external == 1" src="/images/check.png" style="width:20px;">
					</div>
					<div class="col-md-10">
						<p v-if="this.meta['date_connected_external'].value">{{ this.meta['date_connected_external'].value }}</p>
					</div>
					<div class="col-md-10">
						<p v-if="this.meta['date_disconnected_external'].value">{{ this.meta['date_disconnected_external'].value }}</p>
					</div>
					<div class="col-md-12">
						<div v-if="rowMetaComplete('contract_upload_external')">
							<p v-if="clinic.contract_external == 1">{{ getSignKey('f') }}</p>
							<p v-else><i>Inaktiv</i></p>
						</div>
					</div>
				</div>

	      		<div class="form-group summary oddevencol">
					<div class="col-md-10"><b>PT</b></div>
					<div class="col-md-5">
						<img v-if="clinic.contract_pt == 1" src="/images/check.png" style="width:20px;">
					</div>
					<div class="col-md-10">
						<p v-if="this.meta['date_connected_pt'].value">{{ this.meta['date_connected_pt'].value }}</p>
					</div>
					<div class="col-md-10">
						<p v-if="this.meta['date_disconnected_pt'].value">{{ this.meta['date_disconnected_pt'].value }}</p>
					</div>
					<div class="col-md-12">
						<div v-if="rowMetaComplete('contract_upload_pt')">
							<p v-if="clinic.contract_pt == 1" style="white-space: nowrap;">
								<a :href="'https://k.halsoresurs.se/partner/'+clinic.card_token" target="_blank"><b>QR-kodslänk</b></a> ({{ getSignKey('pt') }})
							</p>
							<p v-else><i>Inaktiv</i></p>
							
						</div>
					</div>
				</div>

			</div>

			


		</div>

	</div>

</div>
</template>

<script>

import mixin from './mixin'

export default {

    	mixins: [mixin],

    props: {
        product_areas: {
            required: true
        }
    },

	    data () {
      		return {

      		}
	    },

	    computed: {

	    	regionManager () {
	    		const self = this
	    		let manager = {}
	    		if (self.meta.select_region_manager && self.meta.select_region_manager.value) {
	    			manager = _.find(self.users, function (u) { return u.id == self.meta.select_region_manager.value })
	    		}
	    		return manager
	    	},
	    	contactManager () {
	    		const self = this
	    		let manager = {}
	    		if (self.meta.select_contact_manager && self.meta.select_contact_manager.value) {
	    			manager = _.find(self.users, function (u) { return u.id == self.meta.select_contact_manager.value })
	    		}
	    		return manager
	    	},

        activeProductAreas () {
            return this.product_areas.filter(pa => this.clinic.product_area_ids.indexOf(pa.id) !== -1)
        }

	    },

	    methods: {

	    	getSignKey (type) {
	    		return type + '-' + this.clinic.signature_key
	    	}
	    }

}
</script>
